import PropTypes from 'prop-types';
import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

/* eslint-disable react/no-danger */

const VehicleTitle = ({ packageName, vehicleStockNo, title, vehicleVinNo, tagline, isPageTitle }) => {
    const currentPackage = packageName !== '' && (
        <p
            className="current-package"
            dangerouslySetInnerHTML={{
                __html: packageName,
            }}
        />
    );
    const stockNo = vehicleStockNo &&
        vehicleStockNo !== '' && (
            <p className="vehicle-stockno">
                {LocaleService.t('SUMMARY.STOCK_NUMBER', {
                    stock: vehicleStockNo,
                })}
            </p>
        );

    const vinNo = vehicleVinNo &&
        vehicleVinNo !== '' && (
            <p className="vehicle-vinno">
                {LocaleService.t('SUMMARY.VIN_NUMBER', {
                    vin: vehicleVinNo,
                })}
            </p>
        );
    const taglineTxt = tagline && tagline !== '' && <p className="vehicle-tagline">{tagline}</p>;

    const vehicleName = isPageTitle ? (
        <h1 className="trim is-bold" dangerouslySetInnerHTML={{ __html: title }} />
    ) : (
        <div className="trim is-bold" dangerouslySetInnerHTML={{ __html: title }} />
    );

    return (
        <div className="vehicle-overview__vehicle-title">
            {vehicleName}
            {currentPackage}
            {vinNo}
            {stockNo}
            {taglineTxt}
        </div>
    );
};

VehicleTitle.defaultProps = {
    packageName: '',
    vehicleStockNo: '',
    vehicleVinNo: '',
    isPageTitle: false,
};

VehicleTitle.propTypes = {
    packageName: PropTypes.string,
    vehicleStockNo: PropTypes.string,
    title: PropTypes.string.isRequired,
    vehicleVinNo: PropTypes.string,
    isPageTitle: PropTypes.bool,
};

VehicleTitle.displayName = 'VehicleTitle';

export default VehicleTitle;
